module.exports = __webpack_public_path__ + "static/media/marotte.24dd63ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/collections/marotte.jpg
// module id = 1149
// module chunks = 37